/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Team_Project_LabelInputs */



/**
* | output |
* | --- |
* | "Team Project" |
*
* @param {File_Import_Team_Project_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_team_project_label = /** @type {((inputs?: File_Import_Team_Project_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Team_Project_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Team Project")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teamprojekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto di squadra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Командный проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto de equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームプロジェクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम परियोजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto em Equipe")
	return /** @type {LocalizedString} */ ("Team Project")
});